/**
 * Viron Product Card — global JS
 * Handles: deal-bar animation, quick-view modal, add-to-cart AJAX, card click nav.
 * Loaded once via layout/theme.liquid. Uses event delegation so it works for
 * dynamically injected cards (recommendations, recently-viewed, etc.).
 */
(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     DEAL BAR — animate fills into view
  ───────────────────────────────────────────── */
  function animateDealBars(root) {
    var fills = (root || document).querySelectorAll('.vr-deal__fill:not([data-vr-animated])');
    if (!fills.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.width = (e.target.dataset.fill || 0) + '%';
            e.target.setAttribute('data-vr-animated', '1');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.3 });
      fills.forEach(function (f) { io.observe(f); });
    } else {
      fills.forEach(function (f) {
        f.style.width = (f.dataset.fill || 0) + '%';
        f.setAttribute('data-vr-animated', '1');
      });
    }
  }

  /* ─────────────────────────────────────────────
     QUICK VIEW MODAL
  ───────────────────────────────────────────── */
  var backdrop  = document.getElementById('vr-modal');
  var modalImg  = document.getElementById('vr-modal-img');
  var modalTitle = document.getElementById('vr-modal-title');
  var modalPrice = document.getElementById('vr-modal-price');
  var modalDesc  = document.getElementById('vr-modal-desc');
  var modalLink  = document.getElementById('vr-modal-link');
  var closeBtn   = document.getElementById('vr-modal-close');

  function openModal(card) {
    if (!backdrop) return;
    modalImg.src            = card.dataset.productImg || '';
    modalImg.alt            = card.dataset.productTitle || '';
    modalTitle.textContent  = card.dataset.productTitle || '';
    var price   = card.dataset.productPrice   || '';
    var compare = card.dataset.productCompare || '';
    modalPrice.innerHTML = price +
      (compare && compare !== price
        ? '<span class="compare">' + compare + '</span>'
        : '');
    modalDesc.textContent = card.dataset.productDesc || '';
    modalLink.href        = card.dataset.productUrl  || '#';
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) {
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ─────────────────────────────────────────────
     ADD TO CART (AJAX)
  ───────────────────────────────────────────── */
  function handleAddToCart(btn) {
    var variantId = btn.dataset.variant;
    if (!variantId) return;
    var original = btn.innerHTML;
    btn.innerHTML = 'Adding&hellip;';
    btn.disabled  = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.innerHTML = '&#10003; Added!';
      setTimeout(function () {
        btn.innerHTML = original;
        btn.disabled  = false;
      }, 1800);
      /* Refresh cart count / trigger theme cart drawer */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { cart: cart } })
          );
        });
    })
    .catch(function () {
      btn.innerHTML = 'Error';
      setTimeout(function () {
        btn.innerHTML = original;
        btn.disabled  = false;
      }, 1800);
    });
  }

  /* ─────────────────────────────────────────────
     EVENT DELEGATION — works for dynamic cards
  ───────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    /* Quick View button */
    var qv = e.target.closest('.vr-quick-view');
    if (qv) {
      e.stopPropagation();
      openModal(qv.closest('.vr-card'));
      return;
    }

    /* Add to Cart button */
    var atc = e.target.closest('.vr-add-cart');
    if (atc) {
      e.stopPropagation();
      handleAddToCart(atc);
      return;
    }

    /* Card body click → navigate to product page */
    var card = e.target.closest('.vr-card');
    if (card && !e.target.closest('.vr-btn')) {
      var url = card.dataset.productUrl;
      if (url) window.location.href = url;
    }
  });

  /* ─────────────────────────────────────────────
     INIT on page load + re-init for dynamic sections
  ───────────────────────────────────────────── */
  animateDealBars();

  /* Re-run deal bar animation when new content is injected
     (recommendations, recently-viewed, quick-view, etc.) */
  document.addEventListener('vr:section:loaded', function (e) {
    animateDealBars(e.detail && e.detail.container);
  });

  /* Also hook into common Shopify section events */
  document.addEventListener('shopify:section:load', function () {
    animateDealBars();
  });

})();
